import type * as React from 'react';
import { Text, FillTag } from '@doda/io-react/common';
import styles from './index.module.scss';

const NO_IMAGE_PATH = '/DodaFront/Html/images/icon_kyujin_interview.png';

/**
 * 社員インタビューのProps
 * @param name 名前
 * @param relationship 関係
 * @param entity 属性
 * @param text 本文
 * @param imagePath 写真パス
 */
export interface Props {
  name: string;
  relationship: string;
  entity: string;
  text: string;
  imagePath: string;
}

/**
 * 求人詳細 社員インタビュー パーツ
 * @param name 名前
 * @param relationship 関係
 * @param entity 属性
 * @param text 本文
 * @param imagePath 写真パス
 */
export const Interview = ({
  name,
  relationship,
  entity,
  text,
  imagePath,
}: Props) => {
  return (
    <div className={styles['jobSearchDetail-employeeInterviews__item']}>
      <div className={styles['jobSearchDetail-employeeInterviews__title']}>
        <img
          src={imagePath || NO_IMAGE_PATH}
          alt={entity}
          className={styles['jobSearchDetail-employeeInterviews__img']}
        />
        {relationship !== '' && <FillTag color="blue">{relationship}</FillTag>}
        {(name !== '' || entity !== '') && (
          <div
            className={
              styles['jobSearchDetail-employeeInterviews__employeeName']
            }
          >
            {name !== '' && (
              <Text color="black_pc" size="12">
                {name}
              </Text>
            )}
            {entity !== '' && (
              <Text color="gray" size="12">
                {entity}
              </Text>
            )}
          </div>
        )}
      </div>
      <div className={styles['jobSearchDetail-employeeInterviews__contents']}>
        <Text color="black_pc" size="14--articlePC">
          {text}
        </Text>
      </div>
    </div>
  );
};
